import type { Issue } from "@productlane/zero"

import type { AugmentedProject } from "@/lib/project-or-issue-helpers"

export interface RoadmapStatusGroup {
	label: string
	projects: AugmentedProject[]
	issues: Issue[]
}

/** Projects and issues that share a status name live under one header. */
export function groupByStatusName(
	projectsByStatus: Record<string, AugmentedProject[]>,
	issuesByStatus: Record<string, Issue[]>,
): RoadmapStatusGroup[] {
	const groups = new Map<string, RoadmapStatusGroup>()

	for (const [label, projects] of Object.entries(projectsByStatus)) {
		groups.set(label, { label, projects, issues: [] })
	}
	for (const [label, issues] of Object.entries(issuesByStatus)) {
		const group = groups.get(label)
		if (group) group.issues = issues
		else groups.set(label, { label, projects: [], issues })
	}

	return [...groups.values()].filter(
		(group) => group.projects.length > 0 || group.issues.length > 0,
	)
}
